<template>
  <div class="mb-4">
    <div>
      <span class="text-primary text-size-lg">
        {{ $t('greeting', { name: $store.getters['auth/user'].fullname, email: $store.getters['auth/user'].email }) }}
      </span>
      <div v-if="!isUserVerified" class="text-danger">Your phone is not verified yet. Please verify now!</div>
    </div>

    <div class="row my-4">
      <div class="col-sm-6">
        <b-form-group id="input-group-1" :label="$_t('KW:email')" label-for="input-1">
          <div class="d-flex">
            <b-form-input id="input-1" v-model="email" type="email" required></b-form-input>
            <b-button @click="updateEmail" :disabled="!allowEmailSubmit" variant="primary">{{ emailBtnText }}</b-button>
          </div>
        </b-form-group>

        <b-form-group id="input-group-2" :label="$_t('KW:phoneNumber')" label-for="input-2">
          <div class="d-flex">
            <div class="d-inline-block w-35" v-if="userCountry">
              <div>
                <v-select class="select-filter" v-model="userCountry" label="name" :options="countries" :clearable="false">
                  <template slot="selected-option" slot-scope="{ phonecode }">+{{ phonecode }}</template>
                </v-select>
              </div>
            </div>
            <b-form-input :disabled="!allowPhoneUpdate" type="number" id="input-2" v-model="phone" required></b-form-input>
            <b-button @click="verifyPhone" :disabled="!allowVerify" variant="primary">{{ $t('KW:verify') }}</b-button>
          </div>
          <div class="mt-2">
            <span v-if="isUserVerified" class="text-success"> <i class="fa fa-check-circle fa-lg"></i> Verified</span>
            <span v-if="!isUserVerified" class="text-danger"> <i class="fa fa-times-circle fa-lg"></i> Not Verified</span>
          </div>
        </b-form-group>

        <b-form-group id="input-group-3" :label="$_t('KW:verificationCode')" label-for="input-3" v-if="showCodeInput">
          <b-form-input type="number" id="input-3" v-model="code" required></b-form-input>

          <div class="mt-2">
            <b-button :disabled="code === ''" @click="submitVerification" variant="success">{{ $t('KW:update') }}</b-button>

            <b-btn @click.prevent="requestPhoneCallVerification" sm class="btn-dark" role="button" :disabled="phoneCallRequested">
              <i class="fa fa-phone mr-1"></i>{{ $t('KW:requestPhoneCall') }}
            </b-btn>
            <b-btn @click.prevent="resendVerificationCode" sm class="btn-dark" :disabled="resendTimer !== 0" role="button">
              <i class="fa fa-undo mr-1"></i>{{ $t('KW:resendCode') }}
              <span v-if="resendTimer !== 0"> ({{ resendTimer }}s) </span>
            </b-btn>
          </div>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from 'vue-select';

import { mapGetters } from 'vuex';
export default {
  components: {
    vSelect: VueSelect,
  },
  data() {
    return {
      email: this.$store.getters['auth/user'].email,
      phone: this.$store.getters['auth/user'].phone,
      code: '',
      showCodeInput: false,
      emailBtnText: this.$t('KW:update'),
      resendTimer: 60,
      countries: [],
      userCountry: null,
      allowPhoneUpdate: true,
      phoneCallRequested: false,
      errorMessage: '',
    };
  },
  mounted() {
    this.loadCountries();
  },
  computed: {
    ...mapGetters({ user: 'auth/user', isUserVerified: 'auth/isUserVerified' }),
    allowVerify() {
      return !this.isUserVerified || this.phone != this.user.phone;
    },
    allowEmailSubmit() {
      return this.email != this.user.email;
    },
  },
  methods: {
    loadCountries: async function () {
      this.$http.get('/api/countries').then(resp => {
        this.countries = resp.data;

        if (this.user.country_id) {
          this.userCountry = this.countries.find(c => c.id === this.user.country_id);
        } else {
          this.$set(this, 'userCountry', this.countries[0]);
          this.loadUserCountry();
        }
      });
    },
    loadUserCountry: async function () {
      let country = localStorage.getItem('user_country');
      if (!country) return;

      this.$set(
        this,
        'userCountry',
        this.countries.find(c => c.iso === data.country)
      );
    },
    setupResendTimer() {
      this.resendTimerInterval = setInterval(() => {
        this.resendTimer--;
        if (this.resendTimer === 0) clearInterval(this.resendTimerInterval);
      }, 1000);
    },
    requestPhoneCallVerification() {
      this.$http.post('/api/send-call-verification').then(resp => {
        this.phoneCallRequested = true;
      });
    },
    resendVerificationCode() {
      this.$http.post('/api/resend-verification').then(resp => {
        this.resendTimer = 60;
        this.setupResendTimer();
      });
    },
    verifyPhone() {
      this.$http.post('/api/resend-verification', { phone: this.phone, country_id: this.userCountry.id }).then(resp => {
        if (!resp || !resp.data) return;
        this.showCodeInput = true;
        this.$store.dispatch('auth/updateUserPhone', this.phone);
        this.allowPhoneUpdate = false;

        this.resendTimer = 60;
        this.setupResendTimer();
      });
      // .catch(err => {
      //   console.error(err, 'asdasd');
      //   this.showCodeInput = false;
      //   this.allowPhoneUpdate = true;
      // });
    },
    submitVerification() {
      this.errorMessage = null;

      try {
        const getData = async () => {
          const verifyResp = await this.$http.post('/api/verify', { code: this.code });
          let verifiedAt = verifyResp.data.verified_at;
          if (verifiedAt) {
            this.verificationSuccessEvent(verifiedAt);
          } else {
            this.errorMessage = this.$t('KW:errorWhileVerifyingCode');
          }
        };
        getData();
      } catch (error) {
        this.errorMessage = this.$t('KW:errorWhileVerifyingCode');
      }
    },
    verificationSuccessEvent(verifiedAt) {
      this.$store.dispatch('auth/setUserVerified', verifiedAt).catch(() => {});
      this.$store.dispatch('auth/hideModal').catch(() => {});
      this.allowPhoneUpdate = true;
      this.showCodeInput = false;
    },
    updateEmail() {
      this.$http.put('/api/user/email', { email: this.email }).then(() => {
        this.emailBtnText = this.$t('KW:saved');
        setTimeout(() => {
          this.emailBtnText = this.$t('KW:update');
        }, 2000);
      });
      this.$store.dispatch('auth/updateUserEmail', this.email);
    },
  },
};
</script>

<style>
.dropdown-toggle {
  height: 35px;
}
</style>